module.exports = __webpack_public_path__ + "img/14340598539592.75ac6fb8.jpg";